import Layout from "../../layouts/Layout";
import BreadcrumbArea from "../../components/BreadcrumbArea/BreadcrumbArea";


const PrivacyPolicy = () => {
  return (
    <Layout header={1} footer={1} className="" mainClassName="">
      <BreadcrumbArea
        title={"Privacy Policy / Terms & Conditions"}
        subtitle={"Privacy Policy / Terms and Conditions"}
        className={"breadcrumb-area-two pt-175"}
        showShape={false}
      />
      <div className="privacy-container">
        <h4 className="">Introduction</h4>
        <p>
          Welcome to Innovatix Hub. Your privacy is important to us, and we are
          committed to protecting any personal information that you share with
          us. This Privacy Policy outlines how we collect, use, disclose, and
          safeguard your information when you visit our website the
          <a href="https://www.innovatixhub.com.au/" className="">
            {" "}
            Website
          </a>
          . By using our Website, you agree to the collection and use of
          information in accordance with this Privacy Policy. If you do not
          agree with any part of this policy, please discontinue use of our
          Website.
        </p>
        <h4 className="">Information We Collect</h4>
        <p>We may collect the following types of information:</p>
        <ol>
          <li>
            <h5>Personal Information:</h5>
            <ul>
              <li>Name</li>
              <li>Email address</li>
              <li>Phone number</li>
              <li>Address (if required for services)</li>
              <li>Payment details (when applicable for transactions)</li>
            </ul>
          </li>
          <li>
            <h5> Non-Personal Information:</h5>
            <ul>
              <li>IP address</li>
              <li>Browser type</li>
              <li>Device information</li>
              <li>Operating system</li>
              <li>
                Website usage data (such as pages visited, time spent on pages,
                and interactions)
              </li>
            </ul>
          </li>
          <li>
            <h5>Cookies and Tracking Technologies</h5>
            <p>
              {" "}
              We use cookies and similar technologies to enhance your experience
              on our Website. These technologies help us track user behavior,
              analyze trends, and improve website functionality.
            </p>
          </li>
        </ol>
        <h4>How We Use Your Information</h4>
        <p>We use the information collected for the following purposes:</p>
        <li>To provide, operate, and maintain our Website and services</li>
        <li>To process transactions and payments</li>
        <li>
          To communicate with you, including responding to inquiries and
          providing customer support
        </li>
        <li>
          To send promotional emails, newsletters, and marketing communications
          (you can opt out at any time)
        </li>
        <li>
          To personalize your experience and tailor content based on your
          preferences
        </li>
        <li>To analyze Website usage and improve our services</li>
        <li>
          To comply with legal obligations and enforce our Terms and Conditions
        </li>
        <h4 style={{ marginTop: "1.3rem" }}>Sharing of Information</h4>
        <p>
          We do not sell, rent, or trade your personal information. However, we
          may share information with
        </p>

        <ul>
          <li>
            <strong>Service Providers:</strong> Third-party vendors who assist
            with website hosting, payment processing, analytics, and email
            marketing.
          </li>
          <li>
            <strong>Legal Authorities:</strong> When required by law, court
            order, or to protect our rights, property, or safety.
          </li>
          <li>
            <strong>Business Transfers:</strong> In the event of a merger,
            acquisition, or sale of assets, your information may be transferred
            to the new entity.
          </li>
        </ul>
        <h4>Data Security</h4>
        <p>
          We take reasonable measures to protect your personal information from
          unauthorized access, misuse, loss, or disclosure. However, no method
          of transmission over the internet is 100% secure. While we strive to
          use commercially acceptable means to protect your personal data, we
          cannot guarantee absolute security.
        </p>
        <h4>Marketing Communications</h4>
        <p>
          By providing your email or contact details, you consent to receive
          promotional and marketing materials, including emails and SMS
          messages. You may opt out of these communications at any time by:{" "}
        </p>
        <ul>
          <li>Clicking the "unsubscribe" link in our emails</li>
          <li>Replying "STOP" to SMS messages</li>
          <li>Contacting us directly at [Insert Contact Email]</li>
        </ul>
        <h4>Your Rights and Choices</h4>
        <p>
          Depending on your jurisdiction, you may have the following rights
          regarding your personal data:
        </p>
        <ul>
          <li>
            <strong>Access:</strong> Request a copy of the personal information
            we hold about you.
          </li>
          <li>
            <strong>Correction:</strong> Request corrections to inaccurate or
            incomplete data.
          </li>
          <li>
            <strong>Deletion:</strong> Request the deletion of your personal
            data, subject to legal limitations.
          </li>
          <li>
            <strong>Objection to Processing:</strong> Object to the processing
            of your data for direct marketing purposes.
          </li>
          <li>
            <strong>Data Portability:</strong> Request a structured,
            machine-readable copy of your data.
          </li>
        </ul>
        <p>
          To exercise any of these rights, please contact us at [Insert Contact
          Email].
        </p>
        <h4>Cookies Policy</h4>
        <p>
          Cookies are small files stored on your device that help improve your
          experience. You can manage or disable cookies through your browser
          settings. Please note that disabling cookies may affect certain
          features of our Website.
        </p>
        <h4>Third-Party Links</h4>
        <p>
          Our Website may contain links to third-party websites. We are not
          responsible for the privacy practices of these external sites. We
          encourage users to read the privacy policies of any linked websites
          before providing personal information.
        </p>
        <h4>Children's Privacy</h4>
        <p>
          Our Website is not intended for individuals under the age of 18. We do
          not knowingly collect personal information from children. If we become
          aware of any such data collection, we will take steps to remove the
          information promptly.
        </p>
        <h4>Changes to This Privacy Policy</h4>
        <p>
          We may update this Privacy Policy from time to time. Any changes will
          be posted on this page with an updated "Effective Date." We encourage
          users to review this page periodically to stay informed about how we
          handle personal information.
        </p>
        <h4>Contact Us</h4>
        <p>
          If you have any questions or concerns about this Privacy Policy,
          please contact us at:
        </p>
        <h5>Innovatix Hub </h5>
        <div>Level 3, 85 Macquarie Street, Hobart, TAS</div>
        <div>
          <strong>Email</strong>: info@innovatixhub.com.au
        </div>
        <div>
          <strong>Phone</strong>: +61485972839 / +61480008440
        </div>
        <p>
          By using our Website, you acknowledge that you have read and
          understood this Privacy Policy and agree to its terms.{" "}
        </p>
        <h3>Terms and Conditions</h3>
        <div>
          <strong>Effective Date:</strong> 01/02/2025
        </div>
        <p>
          Welcome to Innovatix Hub. These Terms and Conditions govern your use
          of our website the{" "}
          <a href="https://www.innovatixhub.com.au/">Website</a>. By accessing
          and using our Website, you agree to comply with these terms. If you do
          not agree with any part of these Terms and Conditions, please refrain
          from using our Website.
        </p>
        <h4>Use of Website</h4>
        <p>
          To access and use our Website, you must be at least 18 years old. By
          using this Website, you confirm that you meet this requirement. You
          agree to use our Website only for lawful purposes and refrain from
          engaging in any fraudulent, abusive, or malicious activities.
          Unauthorized access, scraping, or modification of Website content is
          strictly prohibited. We reserve the right to restrict or terminate
          access to users who violate these conditions.
        </p>
        <h4>Intellectual Property Rights</h4>
        <p>
          All content available on our Website, including text, images, logos,
          graphics, and other materials, is either owned by Innovatix Hub or
          licensed to us. This content is protected by intellectual property
          laws. You may not copy, distribute, modify, or use any content without
          obtaining prior written permission from Innovatix Hub. Unauthorized
          use of our intellectual property may result in legal action.
        </p>
        <h4>User Accounts</h4>
        <p>
          If you create an account on our Website, you are responsible for
          maintaining its confidentiality and ensuring its security. You must
          provide accurate and truthful information when registering for an
          account. We reserve the right to suspend or terminate user accounts
          that contain false information or violate these Terms and Conditions.
          Any unauthorized access or use of your account should be reported to
          us immediately.
        </p>
        <h4>Payments and Transactions</h4>
        <p>
          If our services require payment, you agree to provide valid and
          accurate payment information. By proceeding with a transaction, you
          authorize us to charge your account for the corresponding amount. All
          transactions are subject to verification and approval. We reserve the
          right to refuse or cancel any order or transaction at our discretion.
          Once you accept the initial draft of a service or product, Innovatix
          Hub will not be liable for any refunds under any circumstances.
        </p>
        <h4>Limitation of Liability</h4>
        <p>
          While we strive to ensure that the information provided on our Website
          is accurate and reliable, we do not guarantee its completeness or
          accuracy. Innovatix Hub will not be held liable for any direct,
          indirect, incidental, or consequential damages resulting from the use
          of our Website or services. You acknowledge that your use of our
          Website is entirely at your own risk.
        </p>
        <h4>Third-Party Links</h4>
        <p>
          Our Website may contain links to third-party websites for your
          convenience. These external sites are not operated or controlled by
          Innovatix Hub. We do not endorse, guarantee, or assume responsibility
          for the content, policies, or practices of any third-party websites.
          Accessing these third-party sites is done at your own risk, and we
          encourage you to review their terms and privacy policies before
          engaging with them.
        </p>
        <h4>Indemnification</h4>
        <p>
          By using our Website, you agree to indemnify and hold Innovatix Hub,
          its affiliates, employees, and representatives harmless from any
          claims, damages, legal fees, or liabilities resulting from your use of
          the Website, violation of these Terms and Conditions, or infringement
          of any rights of a third party.
        </p>
        <h4>Marketing Communications</h4>
        <p>
          By sharing your email address or any other contact details with us,
          you consent to receive promotional and marketing materials, including
          emails and text messages. These communications may include special
          offers, service updates, and newsletters. If you wish to opt out of
          receiving promotional messages, you can do so at any time by clicking
          the "unsubscribe" link in emails, replying "STOP" to text messages, or
          contacting us directly.
        </p>
        <h4>Changes to Terms</h4>
        <p>
          Innovatix Hub reserves the right to update, modify, or replace these
          Terms and Conditions at any time. Changes will be posted on this page
          with an updated "Effective Date." It is your responsibility to review
          these terms periodically to stay informed. Your continued use of our
          Website after any changes have been made constitutes acceptance of the
          revised Terms and Conditions.
        </p>
        <h4>Governing Law</h4>
        <p>
          These Terms and Conditions are governed by the laws of [Insert
          Jurisdiction]. Any disputes arising from the use of our Website shall
          be resolved in the courts of [Insert Jurisdiction]. By using our
          Website, you consent to the exclusive jurisdiction and venue of these
          courts.
        </p>
        <h4>Contact Us</h4>
        <p>
          If you have any questions, concerns, or requests regarding these Terms
          and Conditions, please contact us at:
        </p>
        <h4>Innovatix Hub</h4>
        <div>Level 3, 85 Macquarie Street, Hobart, TAS</div>
        <div><strong>Email</strong>: info@innovatixhub.com.au</div>
        <div><strong>Phone</strong>: +61485972839 / +61480008440</div>
        <p>
          By using our Website, you acknowledge that you have read, understood,
          and agreed to these Terms and Conditions.
        </p>
      </div>
    </Layout>
  );
};

export default PrivacyPolicy;
